import { render } from "./Countdown.vue?vue&type=template&id=762923c5&ts=true"
import script from "./Countdown.vue?vue&type=script&lang=ts"
export * from "./Countdown.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__